import {
  AfterViewInit,
  Component,
  EventEmitter,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { ArenaCompetition } from '@sparro/app/core/models/competition.model';
import { environment } from '@b2b/env/environment';

@Component({
  selector: 'app-comp-detail-sidenav',
  templateUrl: './comp-detail-sidenav.component.html',
  styleUrls: ['./comp-detail-sidenav.component.scss']
})
export class CompDetailSidenavComponent implements OnInit {
  @Input() competition: ArenaCompetition;
  @Input() modules: any;
  @Input() selected: string;
  @Input() coverScrolled: boolean;
  @Input() isRegistrationRound: boolean;
  @Input() isSubmissionRound: boolean;
  @Input() isVotingRound: boolean;
  @Input() isResultAnnounced: boolean;
  @Output() navLink = new EventEmitter();
  @Output() discipline = new EventEmitter();
  @Output() register = new EventEmitter();
  @Output() entries = new EventEmitter();
  @Output() comments = new EventEmitter();
  defaultImage: string = UNI_CONSTANTS.NO_IMAGE.COMP_OR_PROJECT;

  @ViewChildren('navLinks') links: QueryList<any>;
  @ViewChild('entryNavLink') entryLink: any;
  @ViewChild('commentNavLink') commentLink: any;
  @ViewChild('discussionNavLink') discussionLink: any;
  @ViewChild('topsection') topsection: ElementRef;
  @ViewChild('sidebar') sidebar: ElementRef;

  membershipPageLink: string = 'https://uni.xyz/about/designers/membership';

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private imageOptimizerService: ImageOptimizerService
  ) {}

  ngOnInit(): void {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.sideBarHeight();
  }

  @HostListener('scroll', [])
  sideBarScroll(): void {
    this.sideBarHeight();
  }

  sideBarHeight(): void {
    const element = this.topsection.nativeElement;
    const sidebarContent = this.sidebar.nativeElement;
    if (element && sidebarContent) {
      const height = element.offsetHeight;
      sidebarContent.style.height = `calc(98vh - ${height}px)`;
    }
  }

  goToNavlink(module): boolean {
    if (module.name == 'Jury' && module.count == 0) {
      window.open(`${environment.aboutUrl}about/jurors/`, '_blank');
      return false;
    }
    this.router.navigate([`./${module.path}`], { relativeTo: this.route });
    this.selected = module.name;
    this.navLink.emit(module);
    return false;
  }

  goToEntries() {
    this.router.navigate(['./entries'], { relativeTo: this.route });
    this.selected = 'Entries';
    const module = this.modules.extras.find(module => module.name === 'Entries');
    this.navLink.emit(module);
    return false;
  }

  goToDiscipline(discipline) {
    this.discipline.emit(discipline);
  }

  goToRegistrationPage() {
    this.register.emit();
  }

  submitEntry() {
    if (this.competition.submission_deadline?.link) {
      window.open(`${this.competition.submission_deadline.link}`, '_blank');
    } else {
      window.open(`${environment.profileUrl}submit_entry_redirect`, '_blank');
    }
  }

  renderImage(image: string): string {
    return this.imageOptimizerService.renderImage(image, 320, 160);
  }
  goToTopic(slug: string): string {
    return `${environment.topicUrl}${slug}`;
  }
}
